/* global API_HOSTNAME:false */
/* global closest:false */
/* global dataLayer:false */
/* global Dialog:false */
/* global getStorageItem:false */
/* global gtag:false */
/* global setStorageItem:false */
/* global uuidv4:false */

(function() {
	function sendCookieConsent(consents) {
		gtag('consent', 'update', consents);

		dataLayer.push({'event': 'consent-update'});

		const cookieConsent = getStorageItem('cookie-consent');
		let uuid;
		if (cookieConsent && cookieConsent.uuid) {
			uuid = cookieConsent.uuid;
		} else {
			uuid = uuidv4();
		}

		const storageObject = {
			uuid: uuid,
			consents: consents,
		};

		setStorageItem('cookie-consent', storageObject);

		// Log sent consent for future generations
		const cookiePolicyVersion = document.getElementById('cookie-banner-policy').getAttribute('data-cookie-policy-version');
		const logData = {
			AcceptCookieConsent: {
				adStorage: consents['ad_storage'] ? consents['ad_storage'] === 'granted' : false,
				analyticsStorage: consents['analytics_storage'] ? consents['analytics_storage'] === 'granted' : false,
				cookiePolicyVersion: cookiePolicyVersion,
				consentUrl: window.location.href,
				consentUuid: uuid,
				functionalityStorage: consents['functionality_storage'] ? consents['functionality_storage'] === 'granted' : false,
				personalizationStorage: consents['personalization_storage'] ? consents['personalization_storage'] === 'granted' : false,
				securityStorage: consents['security_storage'] ? consents['security_storage'] === 'granted' : false,
			},
		};
		var request = new XMLHttpRequest();
		request.open('POST', API_HOSTNAME + '/action?action=AcceptCookieConsent', true);
		request.withCredentials = true;
		request.setRequestHeader('Content-Type', 'application/json');
		request.send(JSON.stringify(logData));
	};

	function initBannerDialogs() {
		const cookieConsent = getStorageItem('cookie-consent');

		const cookieBannerGeneralElement = document.getElementById('cookie-banner-general');
		const cookieBannerGeneralDialog = new Dialog(cookieBannerGeneralElement, {
			disableEscClose: !cookieConsent,
		});

		const cookieBannerPolicyElement = document.getElementById('cookie-banner-policy');
		const cookieBannerPolicyDialog = new Dialog(cookieBannerPolicyElement, {
			disableEscClose: !cookieConsent,
		});

		const cookieBannerPreferencesElement = document.getElementById('cookie-banner-preferences');
		const cookieBannerPreferencesDialog = new Dialog(cookieBannerPreferencesElement, {
			disableEscClose: !cookieConsent,
		});
		cookieBannerPreferencesDialog.addEventListeners('.js-open-cookie-preferences');

		if (!cookieConsent) {
			cookieBannerGeneralDialog.open();
		}

		// Opening of cookie policy dialog
		const policyOpeners = document.querySelectorAll('.js-cookie-banner-show-policy');
		Array.prototype.forEach.call(policyOpeners, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				cookieBannerPolicyDialog.open();
				cookieBannerGeneralDialog.close();
				cookieBannerPreferencesDialog.close();
			});
		});

		// Back to genral cookie consent dialog
		const backToGeneralLinks = document.querySelectorAll('.js-cookie-banner-show-general');
		Array.prototype.forEach.call(backToGeneralLinks, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				cookieBannerGeneralDialog.open();
				cookieBannerPolicyDialog.close();
				cookieBannerPreferencesDialog.close();
			});
		});

		// Opening of cookie preferences dialog
		const preferencesOpeners = document.querySelectorAll('.js-cookie-banner-show-preferences');
		Array.prototype.forEach.call(preferencesOpeners, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				cookieBannerPreferencesDialog.open();
				cookieBannerPolicyDialog.close();
				cookieBannerGeneralDialog.close();
			});
		});

		// Accept all cookies
		const acceptAllButtons = document.querySelectorAll('.js-cookie-banner-accept-all');
		Array.prototype.forEach.call(acceptAllButtons, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				sendCookieConsent({
					'ad_storage': 'granted',
					'analytics_storage': 'granted',
					'functionality_storage': 'granted',
					'personalization_storage': 'granted',
					'security_storage': 'granted',
				});

				cookieBannerPreferencesDialog.close();
				cookieBannerPolicyDialog.close();
				cookieBannerGeneralDialog.close();
			});
		});

		// Decline all cookies on preferences dialog
		const declineAllButtons = document.querySelectorAll('.js-cookie-banner-decline-all');
		Array.prototype.forEach.call(declineAllButtons, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				sendCookieConsent({
					'ad_storage': 'denied',
					'analytics_storage': 'denied',
					'functionality_storage': 'denied',
					'personalization_storage': 'denied',
					'security_storage': 'denied',
				});

				cookieBannerPreferencesDialog.close();
				cookieBannerPolicyDialog.close();
				cookieBannerGeneralDialog.close();
			});
		});

		// Accept selected cookies on preferences dialog
		const acceptSelectedButtons = document.querySelectorAll('.js-cookie-banner-accept-selected');
		Array.prototype.forEach.call(acceptSelectedButtons, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				const modal = closest(event.target, '.dialog');
				const analyticsStorageCheckbox = modal.querySelector('#analytics_storage');
				const adStorageCheckbox = modal.querySelector('#ad_storage');

				sendCookieConsent({
					'ad_storage': adStorageCheckbox.checked ? 'granted' : 'denied',
					'analytics_storage': analyticsStorageCheckbox.checked ? 'granted' : 'denied',
				});

				cookieBannerPreferencesDialog.close();
				cookieBannerPolicyDialog.close();
				cookieBannerGeneralDialog.close();
			});
		});

		const intercomActivators = document.querySelectorAll('.js-intercom-activator');
		Array.prototype.forEach.call(intercomActivators, function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();

				var intercom = window.Intercom;

				if (!intercom) {
					cookieBannerPreferencesDialog.open();

					const intercomMessageEl = cookieBannerPreferencesDialog.dialogElement.querySelector('.js-intercom-warning-message');
					if (intercomMessageEl) {
						intercomMessageEl.style.display = '';
					}

					// GA tracking using Google Tag Manager
					dataLayer.push({
						'event': 'gaEvent',
						'eventCategory': 'Intercom cookie consent',
						'eventAction': 'opened',
					});
				}
			});
		});

		// Prefill previous selection to preferences checkboxes when opening
		// preferences dialog
		document.addEventListener('dialogopen', function(e) {
			const details = e.detail;

			if (details.dialogElement && details.dialogElement.getAttribute('id') === 'cookie-banner-preferences') {
				const cookieConsent = getStorageItem('cookie-consent');
				if (cookieConsent) {
					const analyticsStorageCheckbox = details.dialogElement.querySelector('#analytics_storage');
					const adStorageCheckbox = details.dialogElement.querySelector('#ad_storage');
					analyticsStorageCheckbox.checked = cookieConsent.consents && cookieConsent.consents['analytics_storage'] === 'granted';
					adStorageCheckbox.checked = cookieConsent.consents && cookieConsent.consents['ad_storage'] === 'granted';
				}
			}
		});
	}

	// enable cookie banner
	document.addEventListener('DOMContentLoaded', function() {
		initBannerDialogs();
	});
})();
